import { createSlice } from '@reduxjs/toolkit';

type IData = {
  acron_uz: string;
  address: string;
  amount_workers: number;
  auth_capital: string;
  cc_type: string;
  created_at: string | Date;
  created_by: string;
  created_by_department_id: string;
  created_by_organization_id: string;
  created_by_user_id: string;
  db_id: string;
  district_id: string;
  external_id: string;
  fax: string;
  id: string;
  is_active: boolean;
  is_deleted: boolean;
  is_management: string;
  le_id: string;
  le_nm_uz: string;
  level: string;
  location_type: string;
  main_parent_id: string;
  name_json: string;
  name_oz: string;
  name_ru: string;
  name_uz: string;
  okonx: string;
  okpo: string;
  order: string;
  org_level_id: string;
  parent_hierarchy: string;
  parent_id: string;
  phone: string;
  prefix: string;
  reg_date: string;
  reg_no: string;
  region_id: string;
  region_parent_id: string;
  relevance_type: string;
  resolution_blank: string;
  scope: string;
  sequence_index: string;
  short_name_ru: string;
  short_name_uz: string;
  start_dt: string;
  territorial_unit: boolean;
  tin: string;
  type_id: string;
  verified: boolean;
  verified_data: string;
  zip: string;
  details: {
    advancedRejectAndAccept: string;
    bossAccept: string;
    country: string;
    fishkaLanguageFilter: string;
    generalNumberForCancelary: boolean;
    governmentType: string;
    groupedIssue: string;
    isMinjustCenter: boolean;
    is_embassy: boolean;
    licenseFilter: string;
    mainUserSelectType: string;
    minjustOrgTypes: string;
    outbox: string;
    outgoingForCancelary: boolean;
    outgoingSuffixEnabled: string;
    outgoingSuffixPosition: string;
    recipientsMode: string;
    registerManually: boolean;
    regularUserCanSendSubOrg: string;
    resolutionType: string;
    semiAutomaticNumber: boolean;
    userFilesEnabled: string;
    viewAllDocuments: string;
  };
};

type RequestCommandState = {
  loading: boolean;
  data: IData[];
};

// @ts-ignore
const initialState: RequestCommandState = {
  loading: false,
  data: [],
};

export const organizationsListSlice = createSlice({
  name: 'organizationsList',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setData: (state, action) => {
      // @ts-ignore
      state.data = action.payload;
    },
  },
});

export default organizationsListSlice.reducer;
